import { BrowserRouter, Route, Routes } from "react-router-dom";

// Layouts
import { MainLayout } from "./components/layout/main-layout";
import { MapLayout } from "./components/layout/map-layout";

// Pages
import { PlannerPage } from "./pages/planner-page";
import { SiteSettingsPage } from "./pages/site-settings-page";
import { ResultsPage } from "./pages/results-page";
import { ResultsSurveyPage } from "./pages/results-survey-page";

// Context
import { PlannerProvider } from "./services/context/planner-context";
import { ResultsProvider } from "./services/context/results-context";
import { UserProvider } from "./services/context/user-context";

// constants
import { ROUTES } from "./constants/routes";
import { SiteSettingsProvider } from "./services/context/site-settings-context";


function App() {
  return (
    <UserProvider>
      <BrowserRouter>
        <Routes>
          <Route path={ROUTES.MAIN_URL} element={<MainLayout />}>
            {/* map wrapper for the nested routes */}
            <Route path={ROUTES.MAP_WRAPPER} element={<MapLayout />}>
              <Route
                path={ROUTES.RESULTS}
                element={
                  <ResultsProvider>
                    <ResultsPage />
                  </ResultsProvider>
                }
              />
              <Route
                path={ROUTES.SITE_SETTINGS}
                element={
                <SiteSettingsProvider>
                  <SiteSettingsPage />
                </SiteSettingsProvider>
                }
              />
            </Route>
            {/* routes without map */}
            <Route
              path={ROUTES.PLANNER}
              element={
                <PlannerProvider>
                  <PlannerPage />
                </PlannerProvider>
              }
            />
            <Route
              path={ROUTES.RESULTS_SURVEY}
              element={
                <ResultsProvider>
                  <ResultsSurveyPage />
                </ResultsProvider>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </UserProvider>
  );
}

export default App;
